import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, Tooltip } from "@mui/material";

export const MarketplaceText =
  "Marketplace spending counts towards your commitment, depending on the limit specified in your agreement. For example, a limit of 25% for a $1 million commitment, up to $250,000 can be Marketplace spend.";

export const FlexsaveText =
  "Flexsave costs eligible for a commitment, as shown in Commitment Manager, are calculated differently from Cloud Analytics reports.";

export const SupportText =
  "Specific program eligibility rules determine the support value that contributes to your commitment, and this value may differ from the rates shown in Cloud Analytics reports.";

export const CommitmentValueText = "Total monetary amount agreed to spend on cloud services per period";

export const TotalText = "Total Marketplace spend for the month";

export const EligibleText =
  "Total Marketplace spend that counts toward the commitment. The amount becomes $0 once the Marketplace commitment is reached";

export const InfoTooltip = ({ text }: { text: string }) => (
  <Tooltip title={text} arrow placement="right">
    <Box component="span" sx={{ display: "inline-flex", alignItems: "center", ml: 0.5 }}>
      <InfoOutlinedIcon fontSize="small" color="action" />
    </Box>
  </Tooltip>
);
